<template>
  <div class="step-a-wrapper">

    <div><h3 class="mb-20" style="color: #1890ff;">Section 4: Further study</h3></div>
    <a-form layout="vertical" :form="formStepD">
      <a-row :gutter="[16, 16]">
        
        <!-- Q25 Further Study Level -->
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">25. What level you want to further your study ?</span> 
            </template>
            <a-select 
              v-model="form.furtherStudyLevel" 
              show-search 
              placeholder="Select..." 
              v-decorator="[
                'form.furtherStudyLevel',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            >
              <a-select-option value="40">(40) A bachelor’s degree</a-select-option>
              <a-select-option value="50">(50) A graduate diploma</a-select-option>
              <a-select-option value="60">(60) A master’s degree</a-select-option>
              <a-select-option value="70">(70) A higher graduate diploma</a-select-option>
              <a-select-option value="80">(80) A doctor’s degree</a-select-option>
              <a-select-option value="90">(90) A certificate/specialization</a-select-option>
              <a-select-option value="00">(00) Others</a-select-option>
            </a-select>
            <a-input class="mt-20" v-if="form.furtherStudyLevel === '00'" v-model="form.furtherStudyLevelOther" />
          </a-form-item>
        </a-col>

        <!-- Q26 Further Study Field -->
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">26. What field you want to further your study ?</span> 
            </template>
            <a-select 
              v-model="form.furtherStudyField" 
              show-search 
              placeholder="Select..." 
              v-decorator="[
                'form.furtherStudyField',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            >
              <a-select-option value="1">(1) Same field of study</a-select-option>
              <a-select-option value="2">(2) Different field of study</a-select-option>
            </a-select>
            <a-input class="mt-20" v-if="form.furtherStudyField === '2'" v-model="form.furtherStudyFieldOther" />
          </a-form-item>
        </a-col>

        <!-- Q27 Type of Institution -->
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">27. What type of university/institute you want to further your study ?</span> 
            </template>
            <a-radio-group 
              v-model="form.institutionType"
              v-decorator="[
                'form.institutionType',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            >
              <a-radio value="1">(1) Public</a-radio>
              <a-radio value="2">(2) Private</a-radio>
              <a-radio value="3">(3) Overseas</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">University / Institute Name</span> 
            </template>
            <a-input
              v-model="form.institutionName"
              v-decorator="[
                'form.institutionName',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            />
          </a-form-item>
        </a-col>

        <!-- Q28 Reasons for Furthering Study -->
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">28. What are the reasons for furthering your study ?</span> 
            </template>
            <a-select 
              v-model="form.furtherReason" 
              show-search 
              placeholder="Select..." 
              v-decorator="[
                'form.furtherStudyField',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            >
              <a-select-option value="1">(1) Parent’s desire</a-select-option>
              <a-select-option value="2">(2) Career requirement</a-select-option>
              <a-select-option value="3">(3) Scholarship acquirement</a-select-option>
              <a-select-option value="4">(4) My own desire</a-select-option>
              <a-select-option value="0">(0) Others</a-select-option>
            </a-select>
            <a-input class="mt-20" v-if="form.furtherReason === '0'" v-model="form.furtherReasonOther" />
          </a-form-item>
        </a-col>

        <!-- Q29 Problems in Furthering Study -->
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">29. Do you have any problem in furthering your study ?</span> 
            </template>
            <a-checkbox-group 
              v-model="form.studyProblem"
              v-decorator="[
                'form.studyProblem',
                {
                  initialValue: form.studyProblem,
                  rules: [
                    { required: true, type: 'array', min: 1, message: 'Please select You can choose more than 1 item', trigger: 'change' }
                  ]
                }
              ]"
            >
              <a-row :gutter="[16,16]">
                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="01">(01) No</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="02">(02) Insufficient institution information</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="03">(03) Lack of academic qualifications</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="04">(04) Insufficient required knowledge</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="05">(05) Lack of financial support</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="00">(00) Others</a-checkbox></a-col>
              </a-row>
              <a-input class="mt-5" v-if="form.studyProblem.includes('00')" v-model="form.studyProblemOther" />
            </a-checkbox-group>
          </a-form-item>
        </a-col>
      </a-row>

    </a-form>

    <div class="text-right">
      <a-button-group>
        <a-button @click="backSection" type="primary"> <a-icon type="left" />Go back </a-button>
        <a-button @click="submitAndValidateD" type="primary"> Go forward<a-icon type="right" /> </a-button>
      </a-button-group>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formStepD: this.$form.createForm(this, { name: 'stepD' }),
      form: {
        furtherStudyLevel: '',
        furtherStudyLevelOther: '',
        furtherStudyField: '',
        furtherStudyFieldOther: '',
        institutionType: '',
        institutionName: '',
        furtherReason: '',
        furtherReasonOther: '',
        studyProblem: [],
        studyProblemOther: ''
      }
    };
  },
  mounted() {},
  methods: {
    backSection() {
      this.$emit('backSection')
    },
    submitAndValidateD() {
      this.formStepD.validateFields((err, values) => {
        if (!err) {
          this.$emit('updateData', 'stepD', { ...this.form, ...values.form });
          this.$emit('NextSectionSkip', 4); // Section 5
        }
      });
    },
  },
};
</script>

<style scoped>
.step-a-wrapper {
  padding: 20px;
}

.radio-group-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 100%;
}

.radio-group-wrap .radio-text {
  display: inline-block;
  max-width: 100%;
  white-space: normal;      /* อนุญาตให้ขึ้นบรรทัดใหม่ */
  word-break: break-word;   /* ตัดคำถ้าจำเป็น */
  line-height: 1.4;
}
</style>
